import React from 'react';

function UserSolidCircle(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C21.9934 6.47989 17.5201 2.00661 12 2ZM12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6ZM6.834 18.094C9.80666 20.6381 14.1893 20.6381 17.162 18.094C17.265 18.0065 17.3278 17.8809 17.336 17.746C17.3455 17.6126 17.3016 17.481 17.214 17.38C15.9027 15.8671 13.9991 14.998 11.997 14.998C9.99487 14.998 8.09135 15.8671 6.78 17.38C6.69189 17.4816 6.64802 17.6142 6.65816 17.7483C6.6683 17.8823 6.73161 18.0068 6.834 18.094Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default UserSolidCircle;
